import { render } from "./outSend.vue?vue&type=template&id=6e82cd51&scoped=true"
import script from "./outSend.vue?vue&type=script&lang=js"
export * from "./outSend.vue?vue&type=script&lang=js"

import "./outSend.vue?vue&type=style&index=0&id=6e82cd51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e82cd51"]])

export default __exports__